import { useDispatch, useSelector } from "react-redux";
import cms from "../../../constants/cmskeys";
import {
  changeIsCheckedSMS,
  changeSMS,
} from "../../../redux/Slices/SMSSlice";
import cmsParser from "../../Services/CMSParser";

const SMS = ({ cmsLabels }) => {
  const dispatch = useDispatch();
  const { sms, isCheckedSMS } = useSelector((state) => state.sms);

  return (
    <div className="dds__py-2 dds__border-top  dds__border-bottom">
      <div className="dds__checkbox">
        <label className="dds__checkbox__label dds__w-100" htmlFor="lrSMSCheck">
          <input
            className="dds__checkbox__input"
            type="checkbox"
            name="lrSMSCheck"
            id="lrSMSCheck"
            value="lg"
            onChange={() => dispatch(changeIsCheckedSMS(!isCheckedSMS))}
          />
          <span tabIndex="-1">{cmsParser(cms.SMS, cmsLabels)}</span>
        </label>
      </div>
      <div
        className={
          "dds__py-4 dds__px-5 dds__d-none " +
          (isCheckedSMS ? "dds__d-block" : "dds__d-none")
        }
      >
        <div className="dds__row">
          <div className="dds__col--lg-8 dds__col--xl-6">
            <div className="dds__input-text__container dds__row dds__align-items-center dds__py-2">
              <div className="dds__col--md-4 dds__text-md-right">
                <label id="lblLRSMS" htmlFor="txtLRSMS">
                  {cmsParser(cms.SMS_Number, cmsLabels)}
                </label>
              </div>
              <div className="dds__col--md-8">
                <div className="dds__input-text__wrapper dds__flex-grow-1 dds__pl-md-2">
                  <input
                    type="text"
                    className="dds__input-text"
                    maxLength="30"
                    name="txtLRSMS"
                    id="txtLRSMS"
                    required=""
                    aria-labelledby="lblLRSMS"
                    onChange={(e) => dispatch(changeSMS(e.target.value))}
                    value={sms}
                  />
                  <div
                    id="sample-input-feedback"
                    className="dds__invalid-feedback"
                  >
                     {cmsParser(cms.validation_SMS, cmsLabels)}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SMS;
